import ReactMarkdown from "react-markdown";
import type { ReportRow } from "../api/reports";
import { Button } from "../components/Button";

export default function MarkdownReportDetail({
  row,
  busy,
  onRegenerate,
}: {
  row: ReportRow;
  busy: boolean;
  onRegenerate: () => void;
}) {
  return (
    <div className="bg-bg-card border border-border-default rounded-2xl p-7">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <span className="text-[10.5px] font-bold uppercase tracking-widest text-accent-text bg-accent-soft px-2 py-1 rounded">
          Daily report
        </span>
        <span className="text-[12px] font-mono text-text-muted">
          #{row.sourceChannelId} · {row.reportDate}
        </span>
        <span className="text-[12px] text-text-muted">
          compiled {new Date(row.createdAt).toLocaleString()}
        </span>
        <div className="flex-1" />
        <Button variant="primary-dark" disabled={busy} onClick={onRegenerate}>
          {busy ? "Working…" : "Regenerate"}
        </Button>
      </div>

      <article
        className="max-w-none text-[14px] leading-[1.65] text-[#3B463F]
                   [&_h1]:font-display [&_h1]:text-[22px] [&_h1]:font-semibold [&_h1]:mt-6 [&_h1]:mb-3
                   [&_h2]:font-display [&_h2]:text-[16px] [&_h2]:font-semibold [&_h2]:mt-6 [&_h2]:mb-2
                   [&_ul]:pl-5 [&_ul]:list-disc [&_li]:mt-1 [&_a]:text-accent-text"
      >
        <ReactMarkdown>{row.summaryMarkdown}</ReactMarkdown>
      </article>
    </div>
  );
}
